export default "assets/frame-9.d1bde3d2e3a6e66a.png"